'use client';

import { c as _c } from "react/compiler-runtime";
import { useResponsiveStyles } from '@lib/tools/hooks/useResponsiveStyles.js';
import { useRef } from 'react';
import QueuePlan from '../queue-plan/QueuePlan';
import style from './VisualRoot.module.scss';
function VisualRoot(t0) {
  const $ = _c(2);
  const {
    visual
  } = t0;
  const infoRef = useRef(null);
  const bottomLinksRef = useRef(null);
  useResponsiveStyles(bottomLinksRef, infoRef, style.infoWideScreen, style.bottomLinksWideScreen);
  let t1;
  if ($[0] !== visual) {
    t1 = <><div className={style.wrapper}><QueuePlan visualInfo={visual} /></div></>;
    $[0] = visual;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default VisualRoot;